/**
 * 企微 → msOrg 验权：显式传入构建期环境变量，避免依赖「未展开」的默认逻辑；逻辑本体在 @ms/shared-auth。
 * （与 msCentral/his 同源组件保持一致，保证 CRA 对 REACT_APP_* 的注入发生在 client 源码中。）
 */
import React from "react";
import { WecomMsOrgAuthGuard } from "@ms/shared-auth";
import { MsOrgApplicationScopeGate } from "./MsOrgApplicationScopeGate";

const applicationId = process.env.REACT_APP_MSORG_APPLICATION_ID?.trim() || undefined;
const msOrgApiBaseUrl = process.env.REACT_APP_MSORG_API_BASE_URL?.trim() || undefined;
const wecomRedirectUri = process.env.REACT_APP_WECOM_OAUTH_REDIRECT_URI?.trim() || undefined;

const shouldBypassAuthForScreenshot = (): boolean => {
  if (globalThis.window === undefined) return false;
  const params = new URLSearchParams(globalThis.window.location.search);
  return (
    params.get("screenshot") === "1" &&
    Boolean(params.get("hotelId")) &&
    Boolean(params.get("componentType")) &&
    Boolean(params.get("token"))
  );
};

const PcAuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (shouldBypassAuthForScreenshot()) {
    return <>{children}</>;
  }
  return (
    <WecomMsOrgAuthGuard
      applicationId={applicationId}
      msOrgApiBaseUrl={msOrgApiBaseUrl}
      wecomRedirectUri={wecomRedirectUri}
    >
      <MsOrgApplicationScopeGate expectedApplicationId={applicationId}>
        {children}
      </MsOrgApplicationScopeGate>
    </WecomMsOrgAuthGuard>
  );
};

export default PcAuthGuard;
